import { diContainer, serviceNames } from '../diContainer/diContainer';
import ShippingUIState from '../stores/UIState/ShippingUIState';
import AnalyticsRepository from '../repositories/AnalyticsRepository';
import TransactionRepository from '../repositories/TransactionRepository';
import { IShippingMethod } from '../domain/entities/ShippingMethodsCollection/ShippingMethodsCollection';
import { DeliveryOptions } from '../constants/Constants';

export default class SetShippingMethodUseCase {
  private shippingMethodId: number;

  private analyticsRepository: AnalyticsRepository;

  private transactionRepository: TransactionRepository;

  private shippingUIState: ShippingUIState;

  constructor(shippingMethodId: number) {
    this.shippingMethodId = shippingMethodId;
    this.analyticsRepository = diContainer.get(serviceNames.analyticsRepository);
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
    this.shippingUIState = diContainer.get(serviceNames.shippingUIState);
  }

  execute = async (): Promise<void> => {
    try {
      this.shippingUIState.updateContinueLoadingButtonState(true);
      this.shippingUIState.updateShippingMethodLoadingState(true);
      const transaction = await this.transactionRepository.getTransaction();
      const selectedShippingMethod = transaction.getShippingMethodById(this.shippingMethodId);
      await this.transactionRepository.setShippingMethod(selectedShippingMethod.id, true);

      const shipMethod: IShippingMethod = transaction.deliveryOptions
        .find(delivery => delivery.name === DeliveryOptions.HOME_DELIVERY)
        .shipMethods?.find(item => item.id === this.shippingMethodId);

      const shipMethodName = shipMethod ? shipMethod.name : '';
      this.analyticsRepository.selectShippingOptionLinkEvent(shipMethodName);
    } finally {
      this.shippingUIState.updateContinueLoadingButtonState(false);
      this.shippingUIState.updateShippingMethodLoadingState(false);
    }
  };
}
